import { render } from "./VTable.vue?vue&type=template&id=56f83686&scoped=true"
import script from "./VTable.vue?vue&type=script&lang=js"
export * from "./VTable.vue?vue&type=script&lang=js"

import "./VTable.vue?vue&type=style&index=0&id=56f83686&lang=scss&scoped=true"

import exportComponent from "/Users/sherinbloemendaal/projects/spb/pricetiger/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56f83686"]])

export default __exports__